<!--  -->
<template>
  <div class="titleBar">
    <img :src="barObj.img" alt="" />
    <span>{{ barObj.title }}</span>
  </div>
</template>

<script>
export default {
  props: ["barObj"],
};
</script>
<style lang="scss">
// .btn {
//   width: 419px !important;
//   height: 71px !important;
// }
</style>
<style lang="scss">
.titleBar {
  height: 45px;
  line-height: 45px;
  text-align: left;
  border-bottom: 1px dashed rgba(230, 0, 18, 0.2);
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  img {
    width: 17px;
    height: 15px;
    margin-right: 4px;
  }
  span {
    font-size: 16px;
    color: #e50012;
  }
}
</style>
